import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/images/logoFree.webp';
import logoFallback from '../assets/images/logoFree.png';
import '../styles/Header.css';
import { useLanguage } from '../i18n/LanguageContext';
import Picture from './Picture';
import {
    ListIcon,
    ShoppingBagOpenIcon,
    XIcon
} from '@phosphor-icons/react';

const Header = () => {
    const { t, language, setLanguage } = useLanguage();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <header className='site-header'>
            <div className='header-inner'>
                <div className='header-top'>
                    <NavLink to='/' className='brand' onClick={closeMenu}>
                        <Picture
                            webpSrc={logo}
                            fallbackSrc={logoFallback}
                            alt={t('brand.name')}
                        />
                        <div>
                            <span className='brand-title'>
                                {t('brand.title')}
                            </span>
                            <span className='brand-subtitle'>
                                {t('brand.subtitle')}
                            </span>
                        </div>
                    </NavLink>
                    <button
                        type='button'
                        className={`menu-toggle ${
                            isMenuOpen ? 'is-open' : ''
                        }`}
                        onClick={toggleMenu}
                        aria-expanded={isMenuOpen}
                        aria-controls='primary-navigation'
                    >
                        <span className='menu-label'>
                            {isMenuOpen ? t('nav.closeMenu') : t('nav.openMenu')}
                        </span>
                        <span className='menu-icon' aria-hidden='true'>
                            {isMenuOpen ? (
                                <XIcon size={18} weight='regular' />
                            ) : (
                                <ListIcon size={18} weight='regular' />
                            )}
                        </span>
                    </button>
                </div>
                <nav
                    id='primary-navigation'
                    className={`nav ${isMenuOpen ? 'is-open' : ''}`}
                >
                    <NavLink
                        to='/'
                        className={({ isActive }) =>
                            isActive ? 'nav-link active' : 'nav-link'
                        }
                        end
                        onClick={closeMenu}
                    >
                        {t('nav.home')}
                    </NavLink>
                    <NavLink
                        to='/tufting'
                        className={({ isActive }) =>
                            isActive ? 'nav-link active' : 'nav-link'
                        }
                        onClick={closeMenu}
                    >
                        {t('nav.tufting')}
                    </NavLink>
                    <NavLink
                        to='/cartes-pokemon-3d'
                        className={({ isActive }) =>
                            isActive ? 'nav-link active' : 'nav-link'
                        }
                        onClick={closeMenu}
                    >
                        {t('nav.cards')}
                    </NavLink>
                    <NavLink
                        to='/faq'
                        className={({ isActive }) =>
                            isActive ? 'nav-link active' : 'nav-link'
                        }
                        onClick={closeMenu}
                    >
                        {t('nav.faq')}
                    </NavLink>
                    <NavLink
                        to='/contact'
                        className={({ isActive }) =>
                            isActive ? 'nav-link active' : 'nav-link'
                        }
                        onClick={closeMenu}
                    >
                        {t('nav.contact')}
                    </NavLink>
                    <a
                        className='nav-cta'
                        href='mailto:lucasmafrica57@gmail.com'
                        onClick={closeMenu}
                    >
                        <ShoppingBagOpenIcon
                            size={18}
                            weight='regular'
                            aria-hidden='true'
                        />
                        {t('nav.order')}
                    </a>
                    <div
                        className='language-toggle'
                        role='group'
                        aria-label={t('nav.languageLabel')}
                    >
                        <button
                            type='button'
                            className={`language-button ${
                                language === 'fr' ? 'active' : ''
                            }`}
                            onClick={() => {
                                setLanguage('fr');
                                closeMenu();
                            }}
                            aria-pressed={language === 'fr'}
                        >
                            FR
                        </button>
                        <button
                            type='button'
                            className={`language-button ${
                                language === 'en' ? 'active' : ''
                            }`}
                            onClick={() => {
                                setLanguage('en');
                                closeMenu();
                            }}
                            aria-pressed={language === 'en'}
                        >
                            EN
                        </button>
                    </div>
                </nav>
            </div>
        </header>
    );
};

export default Header;
